import React from "react";
import LoginForm from "./HospitalLoginForm";

function HospitalLoginPage() {
	return (
		<div className="container px-4">
			<LoginForm />
		</div>
	);
}

export default HospitalLoginPage;
